import {$controller} from "rapid/index";

const dependencies = ["$mdToast"];

export class acceptInviteController extends $controller {

    constructor($injector, $stateParams) {
        "ngInject";
        super($injector, dependencies);
        this.$stateParams = $stateParams;
        this.user = {
            new_password: "",
            re_new_password: "",
            invitation: this.$stateParams.token,
            first_name: "",
            last_name: ""
        };
    }



    $onSubmit() {
        this.$auth.$http({
            url: "/api/signup/",
            method: "POST",
            data: this.user
        }).then(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(5000)
                    .textContent(`User created!`)
            );
            this.$state.go("auth.signin");
        }).catch(() => {
            this.$mdToast.show(
                this.$mdToast.simple().position("bottom right").hideDelay(3000)
                    .textContent(`Can't accept invitation!`)
            );
        });
    }
}


// WEBPACK FOOTER //
// ./sources/components/auth/accept-invite/accept-invite.controller.js